import { Stack } from '@/components/layout';
import { PLAYER_PROGRESS_TRACKER_BADGE_COUNT } from '@/features/guardian-player/components/player-progress-tracker/constants';
import { useScaling } from '@/hooks';
import { guardianColors, withOpacity } from '@/theme/colors';
import React from 'react';

import { useStyles } from './styles';

type BadgeProgressDotsProps = {
  progress: number;
  color: string;
};

export function BadgeProgressDots({ progress, color }: BadgeProgressDotsProps) {
  const styles = useStyles();
  const { scale } = useScaling();
  const activeCount = Math.floor(progress * PLAYER_PROGRESS_TRACKER_BADGE_COUNT);
  const partialIndex = Math.min(activeCount, PLAYER_PROGRESS_TRACKER_BADGE_COUNT - 1);

  return (
    <Stack direction="row" align="center" gap={scale(4)}>
      {Array.from({ length: PLAYER_PROGRESS_TRACKER_BADGE_COUNT }, (_, index) => {
        const isActive = index < activeCount;
        const isPartial = !isActive && index === partialIndex && progress > 0 && progress < 1;

        if (isPartial) {
          return (
            <Stack
              key={index}
              align="center"
              justify="center"
              backgroundColor={withOpacity(color, 0.2)}
              style={styles.progressDotCurrentOuter}>
              <Stack borderColor={color} style={styles.progressDotCurrentInner} />
            </Stack>
          );
        }

        return (
          <Stack
            key={index}
            backgroundColor={isActive ? color : guardianColors['3']}
            style={styles.progressDot}
          />
        );
      })}
    </Stack>
  );
}
